import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faFacebookF,
  faInstagram,
  faYoutube,
  faTwitch,
} from "@fortawesome/free-brands-svg-icons";

export enum SocialPlatforms {
  Youtube = "yt",
  Instagram = "ig",
  Twitch = "tw",
  Facebook = "fb",
}

export const socialBrandColors: { [k in SocialPlatforms]: string } = {
  fb: "#3b5998",
  ig: "#f09433",
  yt: "#ff0000",
  tw: "#6441a5",
};

export const socialPlatformTitles: { [k in SocialPlatforms]: string } = {
  fb: "Facebook",
  ig: "Instagram",
  yt: "Youtube",
  tw: "Twitch",
};

export const socialPlatformUrls: { [k in SocialPlatforms]: string } = {
  fb: "https://www.facebook.com/",
  ig: "https://www.instagram.com/",
  yt: "https://www.youtube.com/user/",
  tw: "https://www.twitch.tv/",
};

export const socialPlatformIcons: { [k in SocialPlatforms]: IconDefinition } = {
  fb: faFacebookF,
  ig: faInstagram,
  yt: faYoutube,
  tw: faTwitch,
};
